export default __webpack_public_path__ + "static/media/background-light.d6af98ac.svg";